import { RootPage } from "./root";
import { IonicPageModule } from "ionic-angular";
import { NgModule } from "@angular/core";

@NgModule({
    imports: [
        IonicPageModule.forChild(RootPage)
    ],
    declarations: [
        RootPage
    ],
    exports: [
        RootPage
    ],
    entryComponents: [
        RootPage
    ]
})
export class RootPageModule { }



// WEBPACK FOOTER //
// ./src/vas/pages/root/root.module.ts